import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0622b0a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fas fa-check fa-2xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "Checkbox",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["Checkbox__input", { 'input--checked': Boolean(_ctx.value), 'input--disabled': _ctx.disabled }])
    }, [
      (Boolean(_ctx.value))
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : _createCommentVNode("", true)
    ], 2),
    (Boolean(_ctx.label))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["Checkbox__text", { 'text--invalid': _ctx.isInvalid }])
        }, _toDisplayString(_ctx.label), 3))
      : _createCommentVNode("", true)
  ]))
}